const postCloneChecklist = {
  toastr: 'Checklist Clonado',
  toastr1: 'O Modelo foi atualizado com sucesso',
  toastrError: 'Nome já cadastrado',
  toastrError1: 'Insira outro nome',
  toastr1Error: 'Checklist vazio',
  toastr1Error1: 'Insira perguntas no checklist antes de clonar'
};

export default postCloneChecklist;
